
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Timinggates from './pages/Timinggates';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import Booking from './pages/Booking';
import BlogMain from "./components3/BlogShowcasePage";
import BlogDetailsPage from './components3/BlogDetailsPage';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import RefundPolicy from './pages/RefundPolicy';
import CancellationPolicy from './pages/CancellationPolicy';
import Contact from './pages/Contact';
import AikyamBot from "./layout/AikyamBot";
import Membership from './pages/Membership';
import SportsBackgroundHero from './components2/SportsBackgroundHero';
import Fitness from "./pages/Fitness";
import AppPrivacy from './pages/AppPrivacy'; 
import AppsPrivacy from './pages/appprivacy2';
import AthleteMonitoringSystem from './pages/AthleteMonitoringSystem';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}



const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/timing-gates" element={<Timinggates />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/blog" element={<BlogMain />} />
            <Route path="/blog/:slug" element={<BlogDetailsPage />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/cancellation-policy" element={<CancellationPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/membership" element={<Membership/>} />
            <Route path="/fitness" element={<Fitness />} />
            <Route path="/athlete-management-system" element={<AthleteMonitoringSystem />} />
            <Route path="/app-privacy" element={<AppPrivacy />} />
            <Route path="/appsprivacy" element={<AppsPrivacy />} />
          </Routes>
        </main>
        <Footer />
     {/*  <AikyamBot/> */}
      <AikyamBot/>  
      </div>
      <SportsBackgroundHero />
    </Router>
  );
};

export default App;
